module.exports = __webpack_public_path__ + "static/dl1-mac-937b0dccee5dede95f789107bfdec1ed.png";